let relPath = '/app-form/:formType/:applicant'

export const routes = [
    // {
    //     path: `${relPath}/application/:application`,
    //     component: resolve => require(["./views/form.vue"], resolve),
    //     redirect: `${relPath}/application/:application/form`,
    //     name: "base",
    // },
    {
        path: `${relPath}/application/:application`,
        component: (resolve) => require(["./views/form.vue"], resolve),
        name: "form",
    },
    {
        path: `/embedded`,
        component: (resolve) => require(["./views/embedded.vue"], resolve),
        name: "embedded",
    },
    {
        path: `/embedded`,
        component: (resolve) => require(["./layout/index.vue"], resolve),
        name: "embeddedForm",
        props: true
    },
]
